var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ErrorPage"},[_c('div',{staticClass:"pageText"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('common.permissionDenied')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }